/** @format */

import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import OcnkRouting from "./OcnkRouting";
import OcnkSubscriptionRouting from "./OcnkSubscriptionRouting";
import BcartRouting from "./BcartRouting";
import EmochiRouting from "./EmochiRouting";
import BeforeRender from "../pages/common/BeforeRender";
import OldUserRegister from "../pages/common/OldUserRegister";
import OldLogin from "../pages/common/OldLogin";
import NotFound from "../pages/common/NotFound";

// ルートを通す
const Routing = () => {
  return (
    <BrowserRouter>
      <Routes>
        {/* ルートルーティング */}
        <Route path="user_register" element={<BeforeRender Component={OldUserRegister} IsLoggedIn={false} />} />
        <Route path="login" element={<BeforeRender Component={OldLogin} IsLoggedIn={false} />} />
        <Route path="/ocnk-teiki/login" element={<Navigate to="/ocnk_subscription/login" />} />
        {/* 以下はGAで考慮箇所あり */}
        <Route path="*" element={<BeforeRender Component={NotFound} IsLoggedIn={false} />} />
        {/* おちゃのこ上位用ルーティング */}
        {OcnkRouting}
        {/* おちゃのこ定期用ルーティング */}
        {OcnkSubscriptionRouting}
        {/* Bcart用ルーティング */}
        {BcartRouting}
        {/* emochi用ルーティング */}
        {EmochiRouting}
      </Routes>
    </BrowserRouter>
  );
};
export { Routing };
